//const endpoint = "https://osselvelorioonline-back.herokuapp.com";
//const endpoint = "https://osselvelorioonline-api-production.up.railway.app";
const endpoint = "https://cors-sorocaps-beed4061d892.herokuapp.com/52.67.121.155:3001";
//const endpoint = "http://localhost:3001";

export default endpoint

//https://osselvelorioonline-back.herokuapp.com;
//"http://localhost:3001";


// WEBPACK FOOTER //
// ./src/const/backend.js